// extracted by mini-css-extract-plugin
export default {"item":"NavbarLink_item__c3VYB","link":"NavbarLink_link__2F-1r","active":"NavbarLink_active__5DE-J"};